import React from "react";
import { Fade } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

const fadeImages = [
  {
    url: "img/slideShow1.jpg",
    alt: "kutya kozmetika vagas",
  },
  {
    url: "img/slideShow2.jpg",
    alt: "kutya kozmetika Mira",
  },
  {
    url: "img/slideShow3.jpg",
    alt: "kutya kozmetika szekhely",
  },
];

const Slideshow = () => {
  return (
    <div className="slide-container md:tw-w-1/2">
      <Fade>
        {fadeImages.map((fadeImage, index) => (
          <div className="each-fade" key={index}>
            <div className="image-container">
              <img src={fadeImage.url} alt={fadeImage.alt} />
            </div>
            <h2>{fadeImage.caption}</h2>
          </div>
        ))}
      </Fade>
    </div>
  );
};
export default Slideshow;
